import { SWReactIcons } from "@similarweb/icons";
import { i18nFilter } from "app/filters/i18nFilter";
import { WidgetTitleInputWrapper, WidgetTitleLinkWrapper, WidgetTitleWrapper } from "./styledComponents";

// Replaces widget-title-mobile-desktop.html
export const WidgetTitleMobileDesktopTemplate = (props) => {
    const { widgetInstance, titleEditable, widgetTitle, cancelEditTitle, saveTitle, editTitle, onWidgetTitleChange } =
        props;
    const { viewData, viewOptions, titleUtility, dashboardId, apiParams } = widgetInstance;
    const { showTitle, titlePaddingBottom, titleClass, titleType, showTitleTooltip } = viewOptions;
    const { proUrl, title, tooltip } = viewData;

    const getTranslatedValue = (value) => {
        const keySuffix = apiParams.webSource === "Desktop" ? "desktop" : "mobile";
        return i18nFilter()(`${value}.${keySuffix}`);
    };
    const translatedTitle = getTranslatedValue(title);
    const translatedTooltip = getTranslatedValue(tooltip);
    // Todo: need to verify with Elad/ Uri/ Adi if we want to keep existing behaviour of selecting title text when focused.
    //  If yes, we simply need to add the following support to Autosizeinput component: if (this.props.autoSelectWhenFocused) {
    //       this.inputRef?.select();
    //     }
    return (
        <>
            {showTitle ? (
                <WidgetTitleWrapper
                    className={`gridster-no-drag swWidgetTitle ${titleClass}`}
                    titlePaddingBottom={titlePaddingBottom}
                >
                    {titleType === "link" ? (
                        <WidgetTitleLinkWrapper
                            isVisible={!titleEditable}
                            url={proUrl}
                            className="swHeader-title is-link"
                        >
                            {title}
                        </WidgetTitleLinkWrapper>
                    ) : null}
                    <WidgetTitleInputWrapper
                        placeholder=""
                        className="swHeader-title-input"
                        isVisible={titleEditable}
                        maxLength={42}
                        value={widgetTitle}
                        onApply={saveTitle}
                        onCancel={cancelEditTitle}
                        onChange={onWidgetTitleChange}
                        onBlur={saveTitle}
                        isFocused={titleEditable}
                    />
                    {dashboardId ? (
                        <i
                            className={`sw-icon-edit sw-icon-edit-title-dashboard ${
                                titleEditable ? "hiddenImportant" : ""
                            }`}
                            onClick={editTitle}
                        />
                    ) : null}
                    {titleType === "text" ? (
                        <span className={`swHeader-title ${titleClass}`}>{translatedTitle}</span>
                    ) : null}
                    {showTitleTooltip ? (
                        <span
                            className="swHeader-tooltip scss-tooltip scss-tooltip--s"
                            data-scss-tooltip={translatedTooltip}
                        >
                            <SWReactIcons
                                className="info-icon-widget-header"
                                iconName="info"
                            />
                        </span>
                    ) : null}
                </WidgetTitleWrapper>
            ) : null}
        </>
    );
};
